import { forwardRef, useState } from "react";
import { cn } from "../../util/base.util";
import { Eye, EyeClosed } from "lucide-react";

type InputComponentProps = React.ComponentPropsWithoutRef<"input"> & {
    error?: string|string[];
    label?: string;
};

export const Input = forwardRef<HTMLInputElement, InputComponentProps>((props, ref) => {
    const [showPwd, setShowPwd] = useState(false)

    if (props.type === "password") {

        return (
            <div>
                <label>
                <span className={cn(
                    "uppercase text-xs",
                    props.error != undefined ? 'text-error whitespace-pre-wrap' : 'opacity-50'
                )}>{props.label} {props.error != undefined && `- ${props.error}`}</span>
                    <div className={cn(
                        "flex items-center border focus-within:outline outline-offset-2 outline-2 rounded-sm",
                        props.error ? 'border-error outline-error' : 'border-[#ffffff33] focus-within:border-white'
                    )}>
                        <input ref={ref} {...props} type={showPwd ? 'text' : 'password'} className={cn(
                            props.className,
                            'input flex-1 outline-none border-none focus:outline-none'
                        )} />
                        {props.value && (
                            <button onClick={() => setShowPwd(prev => !prev)} className="flex-none btn btn-ghost">{showPwd ? <EyeClosed size={16} /> : <Eye size={16} />}</button>
                        )}
                    </div>
                </label>
            </div>
        );
    }

    return (
        <div>
            <label>
            <span className={cn(
                "uppercase text-xs",
                props.error != undefined ? 'text-error whitespace-pre-wrap' : 'opacity-50'
            )}>{props.label} {props.error != undefined && `- ${props.error}`}</span>
                <input ref={ref} {...props} className={cn(
                    "input",
                    props.className,
                    props.error != undefined && 'input-error'
                )} />
            </label>
        </div>
    );
});